import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import SEOHead from "./components/SEOHead";
import V2Layout from "./v2/V2Layout";
import V2Home from "./v2/pages/V2Home";
import V2About from "./v2/pages/V2About";
import V2Platform from "./v2/pages/V2Platform";
import V2Consultancy from "./v2/pages/V2Consultancy";
import V2Sectors from "./v2/pages/V2Sectors";
import V2SectorPage from "./v2/pages/V2SectorPage";
import V2Resources from "./v2/pages/V2Resources";
import V2Contact from "./v2/pages/V2Contact";

import PreviewHubV2        from "./v2/preview/v2/PreviewHub";
import PreviewHomeV2       from "./v2/preview/v2/PreviewHome";
import PreviewAboutV2      from "./v2/preview/v2/PreviewAbout";
import PreviewPlatformV2   from "./v2/preview/v2/PreviewPlatform";
import PreviewConsultancyV2 from "./v2/preview/v2/PreviewConsultancy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SEOHead />
        <Routes>
          <Route path="/" element={<V2Layout />}>
            <Route index               element={<V2Home />} />
            <Route path="platform"     element={<V2Platform />} />
            <Route path="consultancy"  element={<V2Consultancy />} />
            <Route path="sectors"      element={<V2Sectors />} />
            <Route path="sectors/:slug" element={<V2SectorPage />} />
            <Route path="about"        element={<V2About />} />
            <Route path="resources"    element={<V2Resources />} />
            <Route path="contact"      element={<V2Contact />} />

            {/* Preview / mock pages — for stakeholder review, not yet promoted to live */}
            <Route path="preview/redraft-v2"             element={<PreviewHubV2 />} />
            <Route path="preview/redraft-v2/home"        element={<PreviewHomeV2 />} />
            <Route path="preview/redraft-v2/about"       element={<PreviewAboutV2 />} />
            <Route path="preview/redraft-v2/platform"    element={<PreviewPlatformV2 />} />
            <Route path="preview/redraft-v2/consultancy" element={<PreviewConsultancyV2 />} />

            {/* Legacy redirects (Solutions merged into Platform) */}
            <Route path="solutions" element={<Navigate to="/platform" replace />} />
            <Route path="videra"    element={<Navigate to="/platform" replace />} />
            <Route path="services"  element={<Navigate to="/consultancy" replace />} />
            <Route path="v2"        element={<Navigate to="/" replace />} />
            <Route path="v2/*"      element={<Navigate to="/" replace />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
